module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av494-b4d8a49026a957d3b3e545a38297f092.jpg";